"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";

const HeroStatic = () => {
  return (
    <div
      className="bg-white slider-sec -z-20 before:-z-10"
      style={{ backgroundImage: 'url("../images/service-hero.jpg")' }}
    >
      <div className="max-w-screen-xl mx-5 lg:mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 lg:gap-10 items-center justify-between">
          <div className="p-2 py-16 md:py-16 lg:py-48">
            <h1 className="font-extrabold ">Contact Us</h1>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default HeroStatic;
